const fr_FR = {
    homepage_title: 'Télécharger CalendarTask mobile via QR code',
    homepage_slogn: 'CalendarTask version mobile',
    homepage_ios_download: 'App Store en cours d\'examen...',
    homepage_download: 'Télécharger',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Télécharger CalendarTask mobile via QR code',
    phonedownload_slogan: 'Sync PC et tablette, noter partout',
    phonedownload_send_vip: 'Installez l\'app et recevez un abonnement VIP',
    phonedownload_screenshot: 'Capture d\'écran',
    phodedownload_macos: 'CalendarTask version macOS',
    phodedownload_windows: 'CalendarTask version Windows',
    phodedownload_otherbutton: 'Voir maintenant',
    phodedownload_about: 'Nous contacter',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Sans publicité',
    feature_easy: 'Vue mensuelle, simple et pratique',
    feature_reminder: 'Rappel personnalisé',
    feature_countdown: 'Compte à rebours anniversaire',

    vip_task_succ: 'Réussi. Téléchargez l\'app mobile pour activer le VIP',
    vip_task_error: 'Échec de la réception',

    group_slogn: 'Invitation CalendarTask équipe',

    tt_title: 'CalendarTask',
    tt_share_1: 'Partagé avec vous',
    tt_share_2: 'Emploi du temps',
    tt_share_show_1: 'Scannez le QR code avec l\'app "CalendarTask", PC et mobile afficheront',
    tt_share_show_2: 'l\'emploi du temps',
    tt_share_scan_1: 'Scanner avec',
    tt_share_scan_2: 'l\'app "CalendarTask"',
    tt_share_succ: 'Synchronisation réussie',

    v2_copyright: 'Contact service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Tous droits réservés.',
    v2_download_appstore: 'Télécharger sur l\'App Store',
    v2_download_googleplay: 'Disponible sur Google Play',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Recherchez <span class="name">CalendarTask</span> sur App Store ou Google Play',
    v2_download_ios: 'Télécharger iOS',
    v2_download_android: 'Télécharger Android',
    v2_download_harmonyos: 'Télécharger HarmonyOS',
    v2_sync_status: 'Synchronisation terminée ! 1 enregistrement uploadé, 0 téléchargés',
    v2_feature_title: 'Synchronisation multi-appareils',
    v2_feature_description: 'Sync entre téléphone, tablette et PC'
};
export default fr_FR;
